import FetchService from './fetch-service';
import favoritePlayerService from './favorite-player-services';
import TimeService from './time-service';
import NewsFeedService from './news-feed-service';

export {
    FetchService,
    favoritePlayerService,
    TimeService,
    NewsFeedService,
};
